import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  Avatar,
  Box,
  TableCell,
  TableRow,
  TableContainer,
  Table,
  TableBody,
  Typography,
  Grid,
  Checkbox,
} from '@material-ui/core'
import PropTypes from 'prop-types'
import { Translate } from 'react-localize-redux'
import PlayersTableHead from './PlayersTableHead'
import AvailabilityAndStatusSelectMenu from './AvailabilityAndStatusSelectMenu'
import { PLAYER_AVAILABILITY_TAGS, PLAYER_STATUS_TAGS } from 'constants/match'

const useStyles = makeStyles((theme) => ({
  root: {
    maxHeight: 215,
    '& .MuiTableCell-stickyHeader': {
      backgroundColor: 'white',
      padding: theme.spacing(0, 2),
      textAlign: 'center',
    },
    '& .MuiAvatar-root': {
      marginRight: theme.spacing(1.5),
      height: 30,
      width: 30,
    },
  },
  textAlignCenter: {
    textAlign: 'center',
  },
  reason: {
    fontWeight: 'bold',
  },
  tableRow: {
    verticalAlign: 'baseline',
  },
  [theme.breakpoints.down('sm')]: {
    root: {
      '& .MuiTableCell-sizeSmall': {
        padding: theme.spacing(0.6, 1.2),
      },
      '& .MuiButton-sizeSmall': {
        padding: theme.spacing(0.4, 0.8),
        minWidth: 20,
        '& .MuiSvgIcon-fontSizeSmall': {
          fontSize: 16,
        },
      },
      '& .MuiButton-endIcon.MuiButton-iconSizeSmall': {
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(0),
      },
      '& .MuiAvatar-root': {
        marginRight: theme.spacing(0.6),
        height: 26,
        width: 26,
      },
      '& .MuiTypography-noWrap': {
        width: 90,
      },
    },
  },
}))

const PlayersTable = ({
  matchPlayers,
  isRoster,
  handleSelectPlayer,
  selectedPlayers,
}) => {
  const classes = useStyles()

  return (
    <TableContainer className={classes.root}>
      <Table size="small" stickyHeader>
        <PlayersTableHead isRoster={isRoster} />
        <TableBody>
          {matchPlayers.map((player) => (
            <TableRow
              key={player.uuid}
              className={player.reason && classes.tableRow}
            >
              {!isRoster && (
                <TableCell style={{ maxWidth: 45, paddingLeft: 0 }}>
                  <Checkbox
                    size="small"
                    color="primary"
                    checked={selectedPlayers.some(
                      (p) => p.uuid === player.uuid && p.in_roster
                    )}
                    onChange={() => handleSelectPlayer(player)}
                  />
                </TableCell>
              )}
              <TableCell
                style={{ minWidth: 20 }}
                className={classes.textAlignCenter}
              >
                {player.number}
              </TableCell>
              <TableCell>
                <Grid
                  container
                  direction="column"
                  justifyContent="center"
                  alignItems="baseline"
                >
                  <Box display="flex" alignItems="center">
                    <Avatar alt={player.first_name} src={player.avatar || ''} />
                    <Typography noWrap>
                      {player.first_name} {player.last_name}
                    </Typography>
                  </Box>
                  {player.reason && (
                    <Typography variant="caption">
                      <span className={classes.reason}>
                        <Translate id="matches.highlights.reason" />:
                      </span>{' '}
                      {player.reason}
                    </Typography>
                  )}
                </Grid>
              </TableCell>
              <TableCell className={classes.textAlignCenter}>
                <AvailabilityAndStatusSelectMenu
                  menuItems={PLAYER_AVAILABILITY_TAGS}
                  buttonLabel="Tag"
                  defaultSelectedItem={player.availability?.toLowerCase()}
                  matchPlayerUuid={player.uuid}
                />
              </TableCell>
              <TableCell className={classes.textAlignCenter}>
                <AvailabilityAndStatusSelectMenu
                  menuItems={PLAYER_STATUS_TAGS}
                  buttonLabel="Status"
                  defaultSelectedItem={player.tag || 'none'}
                  matchPlayerUuid={player.uuid}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
PlayersTable.defaultProps = {
  matchPlayers: [],
  isRoster: false,
}
PlayersTable.propTypes = {
  matchPlayers: PropTypes.arrayOf(PropTypes.shape({})),
  isRoster: PropTypes.bool,
  handleSelectPlayer: PropTypes.func.isRequired,
  selectedPlayers: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
    })
  ).isRequired,
}
export default PlayersTable
